import GuardErrorBoundary from './GuardErrorBoundary'
import OnboardingGuard from './OnboardingGuard'
import ChargeGuard from './ChargeGuard'
import AppConnectGuard from './AppConnectGuard'

function GuardProvider({ children }: { children: JSX.Element }): JSX.Element {
  return (
    <GuardErrorBoundary>
      <AppConnectGuard>
        <OnboardingGuard>
          <ChargeGuard>{children}</ChargeGuard>
        </OnboardingGuard>
      </AppConnectGuard>
    </GuardErrorBoundary>
  )
}

export default GuardProvider
